import Splide from '@splidejs/splide';

(() => {
  const articles = document.querySelector('.js-blog-articles');
  if (!articles) return;

  const moveArticles = () => {
    const target = document.querySelector('.signup-blog__blog .splide__track');
    if (!target) return;

    const splideList = document.createElement('div');
    splideList.classList.add('splide__list');
    const tiles = articles.querySelectorAll('.tile');
    tiles.forEach((tile) => {
      tile.classList.add('splide__slide');
      splideList.appendChild(tile);
    });

    target.appendChild(splideList);
  };

  // splide setup
  const sliders = document.querySelectorAll('.signup-blog__blog .splide');
  const options = {
    type: 'loop',
    rewind: true,
    gap: 20,
    perPage: 2,
    perMove: 1,
    clones: 2,
    arrows: false,
    pagination: false,
    padding: { right: 280 },
    arrowPath: 'M22 9a1 1 0 0 0 0 1.42l4.6 4.6H3.06a1 1 0 1 0 0 2h23.52L22 21.59A1 1 0 0 0 22 23a1 1 0 0 0 1.41 0l6.36-6.36a.88.88 0 0 0 0-1.27L23.42 9A1 1 0 0 0 22 9Z',
    breakpoints: {
      1500: {
        perPage: 1,
      },

      1200: {
        perPage: 2,
        padding: { right: 0 },
      },

      600: {
        perPage: 1,
      },
    },
  };

  $(document).ready(() => {
    moveArticles();

    sliders.forEach((item) => {
      const newSplide = new Splide(item, options);
      newSplide.mount();
    });
  });
})();
